const dayjs = require('dayjs')
const timezone = require('dayjs/plugin/timezone')
const advancedFormat = require('dayjs/plugin/advancedFormat')
const utc = require('dayjs/plugin/utc')
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(advancedFormat)

const defaultDateFilterShort = function(dte, tz) {
  // If timezone is not set, guess!
  if (tz === undefined || !tz) {
    tz = dayjs.tz.guess(true)
  }

  return dayjs(dte, 'YYYY-MM-DD hh:mm:ss Z').tz(tz).format('Do MMM YYYY')
}

export default defaultDateFilterShort
